/**
 * Safe Storage Utility
 * 
 * Wraps localStorage for NON-SENSITIVE public data only.
 * Used for: site configuration cache, cookie preferences, UI state.
 * NOT used for: auth tokens, personal data, passwords.
 * 
 * Auth tokens are handled via httpOnly cookies (see AuthContext.js).
 */

const isDev = process.env.NODE_ENV === 'development';

// Difesa in profondità: blocca l'uso accidentale di chiavi sensibili in localStorage.
// I token di autenticazione vivono SOLO in cookie httpOnly + memoria (AuthContext).
const SENSITIVE_PATTERNS = /token|password|secret|credential|jwt|auth/i;

const assertNotSensitive = (key) => {
  if (SENSITIVE_PATTERNS.test(key)) {
    if (isDev) console.error(`safeStorage: la chiave "${key}" sembra contenere dati sensibili — usare cookie httpOnly, non localStorage.`);
    return false;
  }
  return true;
};

const safeStorage = {
  get(key) {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (err) {
      if (isDev) console.warn(`safeStorage.get(${key}) failed:`, err.message);
      return null;
    }
  },

  set(key, value) {
    if (!assertNotSensitive(key)) return;
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      if (isDev) console.warn(`safeStorage.set(${key}) failed:`, err.message);
    }
  },

  remove(key) {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      if (isDev) console.warn(`safeStorage.remove(${key}) failed:`, err.message);
    }
  }
};

export default safeStorage;
